import React, { useMemo } from 'react';
import TriggerRenewalsContent from 'components/tools/trigger-renewals/TriggerRenewalsTable';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import {
  TriggerRenewalsPageStore,
  TriggerRenewalsPageStoreContext,
} from 'store/pages/tools/trigger-renewals/pageStore';

const TriggerRenewalsPage: React.FC = () => {
  const pageStore = useMemo(() => new TriggerRenewalsPageStore(), []);
  return (
    <TriggerRenewalsPageStoreContext.Provider value={pageStore}>
      <NoSidebarPageLayout pageHeader={{ title: 'Trigger Renewals' }} contentWidth="wide">
        <TriggerRenewalsContent />
      </NoSidebarPageLayout>
    </TriggerRenewalsPageStoreContext.Provider>
  );
};

export default TriggerRenewalsPage;
